import React from "react";
import NoteText from "../../components-text/note-text";
import { ERROR_MESSAGES } from "../../../constants/errorMessages";
import { InputMonthYearContainer } from "./input-month-year-style";
import { InputMonthYearProps } from "./input-month-year-types";

const InputMonthYear = ({
  value,
  error,
  label,
  id,
  required,
  onChange,
  disabled,
  noData,
}: InputMonthYearProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");

    if (inputValue.length > 6) {
      return;
    }

    if (inputValue.length >= 2) {
      // Añade la barra "/" tras introducir 2 dígitos
      inputValue = inputValue.slice(0, 2) + "/" + inputValue.slice(2);
    }

    onChange(inputValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Permite borrar la barra "/" que crea automáticamente el handleChange tras introducir 2 dígitos
    if (e.key === "Backspace" && value.length === 3) {
      e.preventDefault();
      onChange(value.slice(0, 2));
    }
  };

  const validate = (value: string) => {
    if (!value) return true;
    const todayYear = new Date().getFullYear();
    const todayMonth = new Date().getMonth() + 1;
    const [month, year] = value.split("/");

    if (month && (parseInt(month) < 1 || parseInt(month) > 12)) {
      return false;
    }

    if (year && year.length === 4 && parseInt(year) > todayYear) {
      return false;
    }

    if (parseInt(year) === todayYear && parseInt(month) > todayMonth) {
      return false;
    }

    return true;
  };

  return (
    <InputMonthYearContainer className="selectBox">
      <div className={`input-box-main-field input required ${required && "required"}`}>
        <input
          type="text"
          value={noData ? "" : value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="MM/YYYY"
          maxLength={7}
          id={id}
          name={id}
          disabled={disabled}
        />
        {(error || !validate(value)) && (
          <div className="input-box-error">
            <NoteText>
              <p>
                {!validate(value) && `${ERROR_MESSAGES["invalid-month-year-input"]}. `}
                {error}
              </p>
            </NoteText>
          </div>
        )}
      </div>
      <label htmlFor={id}>{label}</label>
    </InputMonthYearContainer>
  );
};

export default InputMonthYear;
